export default __webpack_public_path__ + "static/media/banner-22.ef7c71c5.jpg";